<template>
  <div class="attendance-leave-audit-container animated fadeInRight padding">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" :model="searchForm" class="search-form">
            <el-form-item label="员工姓名">
              <el-input v-model="searchForm.staffName" placeholder="请输入员工姓名" clearable />
            </el-form-item>
            <el-form-item label="请假类型">
              <el-select v-model="searchForm.leaveType" placeholder="请选择请假类型" clearable>
                <el-option label="事假" value="1001" />
                <el-option label="病假" value="1002" />
                <el-option label="年假" value="1003" />
                <el-option label="调休" value="1004" />
                <el-option label="婚假" value="1005" />
                <el-option label="产假" value="1006" />
                <el-option label="陪产假" value="1007" />
                <el-option label="丧假" value="1008" />
                <el-option label="补卡假" value="1009" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
              <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>请假待审批列表</span>
          </div>
          <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column prop="leaveId" label="请假ID" align="center" width="180" />
            <el-table-column prop="staffName" label="申请人" align="center" width="100" />
            <el-table-column prop="leaveTypeName" label="请假类型" align="center" width="100" />
            <el-table-column prop="startTime" label="开始时间" align="center" width="160" />
            <el-table-column prop="endTime" label="结束时间" align="center" width="160" />
            <el-table-column prop="leaveHours" label="时长(小时)" align="center" width="100" />
            <el-table-column prop="reason" label="事由" align="center" show-overflow-tooltip />
            <el-table-column label="附件" align="center" width="80">
              <template slot-scope="scope">
                <el-image
                  v-if="hasAttachment(scope.row.attachmentList)"
                  :src="buildFileUrl(scope.row.attachmentList[0].fileRelId)"
                  :preview-src-list="buildPreviewUrls(scope.row.attachmentList)"
                  fit="cover"
                  style="width: 36px; height: 36px; cursor: pointer;"
                />
                <span v-else class="text-muted">—</span>
              </template>
            </el-table-column>
            <el-table-column prop="stateName" label="状态" align="center" width="100" />
            <el-table-column prop="createTime" label="申请时间" align="center" width="160" />
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="handleAudit(scope.row, '1100')">通过</el-button>
                <el-button size="mini" type="danger" @click="handleAudit(scope.row, '1200')">拒绝</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page.sync="page.current"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="page.size"
            :total="page.total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      title="审批意见"
      :visible.sync="auditDialogVisible"
      width="500px"
      @close="resetAuditDialog"
    >
      <el-form :model="auditForm" label-width="80px">
        <el-form-item label="请假人">
          <span>{{ currentRow.staffName }}</span>
        </el-form-item>
        <el-form-item label="请假时段">
          <span>{{ currentRow.startTime }} 至 {{ currentRow.endTime }}</span>
        </el-form-item>
        <el-form-item label="附件" v-if="hasAttachment(currentRow.attachmentList)">
          <el-image
            v-for="item in currentRow.attachmentList"
            :key="item.fileRelId"
            :src="buildFileUrl(item.fileRelId)"
            :preview-src-list="buildPreviewUrls(currentRow.attachmentList)"
            fit="cover"
            style="width: 80px; height: 80px; margin-right: 8px; cursor: pointer;"
          />
        </el-form-item>
        <el-form-item label="审批结果">
          <el-tag :type="auditForm.auditCode === '1100' ? 'success' : 'danger'">
            {{ auditForm.auditCode === '1100' ? '通过' : '拒绝' }}
          </el-tag>
        </el-form-item>
        <el-form-item label="审批意见">
          <el-input v-model="auditForm.auditMessage" type="textarea" :rows="3" placeholder="请输入审批意见" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAudit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listAttendanceLeaveAudits, auditAttendanceLeave } from '@/api/attendance/attendanceLeaveAuditApi'

export default {
  name: 'AttendanceLeaveAuditList',
  data() {
    return {
      loading: false,
      searchForm: {
        staffName: '',
        leaveType: ''
      },
      tableData: [],
      page: { current: 1, size: 10, total: 0 },
      auditDialogVisible: false,
      auditForm: { auditCode: '1100', auditMessage: '' },
      currentRow: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getCurrentUserId() {
      try {
        const user = JSON.parse(localStorage.getItem('userInfo') || '{}')
        return user.userId || user.id || ''
      } catch (e) {
        return ''
      }
    },
    async getList() {
      try {
        this.loading = true
        const params = {
          page: this.page.current,
          row: this.page.size,
          userId: this.getCurrentUserId(),
          ...this.searchForm
        }
        const { data, total } = await listAttendanceLeaveAudits(params)
        this.tableData = data || []
        this.page.total = total || 0
      } catch (e) {
        this.$message.error('获取列表失败：' + (e.message || ''))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.page.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = { staffName: '', leaveType: '' }
      this.getList()
    },
    handleSizeChange(val) { this.page.size = val; this.getList() },
    handleCurrentChange(val) { this.page.current = val; this.getList() },
    handleAudit(row, auditCode) {
      this.currentRow = row
      this.auditForm.auditCode = auditCode
      this.auditForm.auditMessage = ''
      this.auditDialogVisible = true
    },
    resetAuditDialog() {
      this.auditForm = { auditCode: '1100', auditMessage: '' }
      this.currentRow = {}
    },
    async confirmAudit() {
      try {
        const payload = {
          leaveId: this.currentRow.leaveId,
          staffId: this.getCurrentUserId(),
          communityId: this.getCommunityId(),
          auditCode: this.auditForm.auditCode,
          auditMessage: this.auditForm.auditMessage
        }
        const res = await auditAttendanceLeave(payload)
        if (res.code === 0) {
          this.$message.success('审批成功')
          this.auditDialogVisible = false
          this.getList()
        } else {
          this.$message.error('审批失败：' + (res.msg || ''))
        }
      } catch (e) {
        this.$message.error('审批失败：' + (e.message || ''))
      }
    },
    // ============ 附件展示 ============
    hasAttachment(list) {
      return Array.isArray(list) && list.length > 0
    },
    buildFileUrl(fileRelId) {
      if (!fileRelId) return ''
      return `/callComponent/download/getFile/file?fileId=${fileRelId}&communityId=-1&time=${new Date().getTime()}`
    },
    buildPreviewUrls(list) {
      if (!Array.isArray(list)) return []
      return list.map(it => this.buildFileUrl(it.fileRelId))
    }
  }
}
</script>

<style lang="scss" scoped>
.attendance-leave-audit-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
  ::v-deep .el-card {
    border-radius: var(--ds-radius-md);
    border: 1px solid var(--ds-gray-300);
    box-shadow: var(--ds-shadow-sm);
    margin-bottom: var(--ds-spacing-lg);
  }
  .search-form { text-align: left; }
}
</style>
